/**
 * Handle attempts to access data that requires a login (redirects the user
 * to the login page, with a URL set so that they can return)
 */
import {useLocation} from "react-router-dom-v5-compat";

import {getLoginUrl, redirect} from "@khan/urls";

import FullPageSpinner from "../full-page-spinner/full-page-spinner.tsx";

export default function LoginRequired() {
    const {pathname, search, hash} = useLocation();
    const continueUrl = pathname + search + hash;
    const url = getLoginUrl(continueUrl);
    redirect(url);
    return <FullPageSpinner />;
}
